import { ALL_COMPANIES } from "../../types";

const CompaniesReducer = (state = [], action) => {
    switch (action.type) {

        case ALL_COMPANIES: {
            state = action.payload;
        }
    };
    return state;
};

export default CompaniesReducer;